import React, {Component} from 'react';
import {ADMIN_API_URL} from "../../../constants/api_routes";
import {Button, Divider, Form, Grid, Header, Label, Segment,Popup,Ref} from "semantic-ui-react";
import ListingContainer from "../../../containers/listing_container";
import validatePasswordStrength from "../../../utils/password_validation";

class CreateAdminUser extends Component {

    constructor(props){
        super(props);
        this.state = {
            pswdLength:false,
            pswdLC:false,
            pswdUC:false,
            pswdSym:false,
            pswdNum:false

        }
    }

    handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        this.setState({disableSave:true});
        this.props.create(ADMIN_API_URL, formData, this.handleCreateResponse);

    };
    handleCreateResponse = (response) => {
        if (response.success) {
            this.props.onSuccess();
        }
        else {
            this.setState({disableSave:false,error:true,errorMessage:response.message});
        }
    };

    validatePassword = (password) => {
        this.setState({
            pswdLength:validatePasswordStrength.charLength(password),
            pswdLC:validatePasswordStrength.lowercase(password),
            pswdUC:validatePasswordStrength.uppercase(password),
            pswdSym:validatePasswordStrength.special(password),
            pswdNum:validatePasswordStrength.hasNumber(password),
        });
    };

    render() {
        return (
            <div>
                <Header as='h2' textAlign='center'>
                    Create New Admin User
                </Header>

                <Form onSubmit={this.handleSubmit}>
                    <Grid stackable>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Profile Details
                                </Label>
                                <p></p>

                                <Form.Input label='Name:' fluid icon='user' iconPosition='left' placeholder='Name'
                                            type='text' name="name"
                                            required/>
                                <Form.Input label='Email Address:' fluid icon='mail' iconPosition='left'
                                            placeholder='E-mail address'
                                            name="user[email]" required/>
                                <Popup trigger={
                                <Form.Input label='Password' fluid icon='lock' iconPosition='left'
                                            placeholder='Password'
                                            type='password' name="user[password]" pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])(?=.*\d).{6,}"
                                            onChange={(e) => {this.validatePassword(e.target.value)}}
                                            required/>}
                                       content={<Segment>
                                            <p className={this.state.pswdLength?"info-success":"info-negative"}>Password must be 6 chars or more</p>
                                            <p className={this.state.pswdLC?"info-success":"info-negative"}>Must have atleast 1 lowercase</p>
                                            <p className={this.state.pswdUC?"info-success":"info-negative"}>Must have atleast 1 uppercase</p>
                                            <p className={this.state.pswdSym?"info-success":"info-negative"}>Must have atleast 1 special character</p>
                                            <p className={this.state.pswdNum?"info-success":"info-negative"}>Must have atleast 1 Number</p>
                                       </Segment>}
                                       on="focus"
                                       position="right center"
                                       wide
                                       hideOnScroll
                                       />
                                <Form.Input label='Mobile Number' fluid icon='mobile' iconPosition='left'
                                            placeholder='328659286'
                                            type='text' name="mobile_number"
                                            required/>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment>
                                <Label color='blue' ribbon>
                                    Address Details
                                </Label>
                                <p></p>
                                <Form.Input label='Address Line 1' fluid placeholder='Street'
                                            type='text' name="line1"
                                            required/>
                                <Form.Input label='Address Line 2' fluid placeholder='Landmark'
                                            type='text' name="line2"
                                />
                                <Form.Group widths={2}>
                                    <Form.Input label='Locality' fluid placeholder='Region'
                                                type='text' name="locality"
                                    />
                                    <Form.Input label='City' fluid placeholder='City'
                                                type='text' name="city"
                                    />
                                </Form.Group>
                                <Form.Group widths={2} className='field'>
                                    <Form.Input label='Country' fluid placeholder='Country'
                                                type='text' name="country"
                                    />
                                    <Form.Input label='Postcode' fluid placeholder='C2PN57'
                                                type='text' name="postcode" required
                                    />
                                </Form.Group>
                            </Segment>
                        </Grid.Column>
                        <div className="submit-buttons">
                            <Button primary fluid disabled={this.state.disableSave}>Create User</Button>
                        </div>
                    </Grid>
                </Form>
            </div>
        );
    }

}

export default ListingContainer(CreateAdminUser);


// WEBPACK FOOTER //
// ./src/views/user/admin/create_user.js